import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const getDefaultState = () => {
  return {
    numbers: null,
    checkVerifyNumberByCallCounter: -1,
    verifyByCallCallingInProgress: false,
    callerRegions: [],
    inProgress: {
      fetchNumbers: false,
      setNumberAsPrimarty: false,
      deleteNumber: false,
      getCallerRegions: false,
      setCallerRegion: false,
      addNumber: false,
      verifyByCall: false,
      verifyByCallCalling: false,
      verifyBySMS: false,
      verifyWithRecivedCode: false
    },
    errors: {
      fetchNumbers: false,
      setNumberAsPrimarty: false,
      deleteNumber: false,
      getCallerRegions: false,
      setCallerRegion: false,
      addNumber: false,
      verifyByCall: false,
      verifyByCallCalling: false,
      verifyBySMS: false,
      verifyWithRecivedCode: false
    }
  }
}

const state = getDefaultState()

mutations.RESET_STATE = (state) => {
  Object.assign(state, getDefaultState())
}
actions.reset = ({ commit }) => {
  commit('RESET_STATE')
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user/numbers/index.js